// Point Festival (พอยท์ แลก ลุ้น) — temporary lucky draw campaigns, one per sale group.
// Uses the existing lucky draw backend (GET /lucky_draws, POST /lucky_draws/:id/join).
// To remove: set POINT_FESTIVAL_ENABLED to false (hides the button on /rewards).
import store from "@/store";

export const POINT_FESTIVAL_ENABLED = true;

const SALE_GROUP_BY_SALE_TYPE = {
  RETAIL: "retail",
  WHOLESALE: "wholesale",
  // misspelled value stored for some shops
  WHOLSALE: "wholesale",
  EXCLUSIVITY: "wholesale",
};

// Everything that differs between the two campaigns. `type` must match the lucky draw's
// type in the backend, which only lets a shop join the type of its own sale group.
const CAMPAIGNS = {
  retail: {
    group: "retail",
    type: "point_festival",
    kv: require("@/assets/point_festival_kv.jpg"),
    // landscape artwork for the top of the activity page (shown whole, not cropped)
    banner: require("@/assets/point_festival_banner.jpg"),
    // used when the lucky draw has no announceAt
    announceAt: "2026-12-17T15:00:00+07:00",
    info: {
      title: "Point Festival",
      subtitle: "พอยท์ แลก ลุ้น Season 7",
      period: "1-30 พ.ย. 69",
      periodNote: "สิ้นสุด 23.59 น.",
      rateLabel: "ลุ้นรางวัล",
      rate: "1 พอยท์ = 1 สิทธิ์",
      eligible: "สำหรับร้านค้าปลีก ร้านอาหาร และร้านค้าเล็กอื่นๆ ช่องทางออนไลน์และออฟไลน์",
      drawLabel: "จับฉลาก",
      drawAt: ["16 ธ.ค. 69", "เวลา 11.00 น."],
      announceLabel: "ประกาศรายชื่อ",
      announceAt: ["17 ธ.ค. 69", "เวลา 15.00 น."],
    },
  },
  wholesale: {
    group: "wholesale",
    type: "point_festival_wholesale",
    kv: require("@/assets/point_festival_wholesale_kv.jpg"),
    // no landscape artwork yet, so the activity page shows the key visual
    banner: require("@/assets/point_festival_wholesale_kv.jpg"),
    announceAt: "2026-12-16T15:00:00+07:00",
    info: {
      title: "BEVFAMILY",
      subtitle: "ส่งท้ายพอยท์เก่าต้อนรับพอยท์ใหม่",
      period: "3-30 พ.ย. 69",
      periodNote: "สิ้นสุด 23.59 น.",
      rateLabel: "เงื่อนไขคะแนน",
      rate: "1 พอยท์ = 1 สิทธิ์",
      eligible: null,
      drawLabel: "จับรางวัล",
      drawAt: ["15 ธ.ค. 69", "เวลา 10.00 น."],
      announceLabel: "ประกาศรายชื่อ\nผู้โชคดี",
      announceAt: ["16 ธ.ค. 69", "เวลา 15.00 น."],
    },
  },
};

function customerSaleType() {
  return (store.state.user_data || {}).customerSaleType;
}

export function saleGroup(saleType) {
  return SALE_GROUP_BY_SALE_TYPE[(saleType || "").toUpperCase()] || "retail";
}

export function currentCampaign() {
  return CAMPAIGNS[saleGroup(customerSaleType())];
}

export function isSaleTypeKnown() {
  return Boolean(customerSaleType());
}

// A deep link can open the festival before any page has loaded the profile.
export async function loadCampaign(jwt) {
  if (!isSaleTypeKnown()) {
    const res = await fetch(process.env.VUE_APP_API_URL + "/me", {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });
    if (res.status === 200) {
      store.dispatch("setUserData", await res.json());
    }
  }
  return currentCampaign();
}

// Click/step tracking. Sent to Google Tag Manager as a custom event "point_festival"
// (GTM needs a trigger + GA4 tag for it), and to the legacy Matomo helper.
export function trackFestival(action, params = {}) {
  const payload = { sale_group: currentCampaign().group, ...params };
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "point_festival", festival_action: action, ...payload });
  } catch (error) {
    console.log(error);
  }
  window.$pushEvent("point_festival", action, JSON.stringify(payload));
}

export async function fetchPointFestival(jwt, campaign) {
  const res = await fetch(process.env.VUE_APP_API_URL + "/lucky_draws", {
    method: "GET",
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  });
  if (res.status !== 200) {
    throw "fetchPointFestival status " + res.status;
  }
  const list = ((await res.json()) || []).filter((item) => item.type === campaign.type);
  return (
    list.find((item) => item.isActive === true) ||
    // after the campaign ends, fall back to the latest one (for the winners page)
    list.sort((a, b) => new Date(b.announceAt || 0) - new Date(a.announceAt || 0))[0] ||
    null
  );
}

export function getAnnounceDate(luckyDraw, campaign) {
  return new Date((luckyDraw && luckyDraw.announceAt) || campaign.announceAt);
}

export function isAnnounced(luckyDraw, campaign) {
  return new Date() >= getAnnounceDate(luckyDraw, campaign);
}

// 20 พ.ย. 69
export function formatThaiShortDate(date) {
  return date.toLocaleDateString("th-TH", {
    day: "numeric",
    month: "short",
    year: "2-digit",
  });
}
